import { site } from '@/content/site';
import { about } from '@/content/about';
import { TweetEmbed } from '@/components/TweetEmbed';

export function Home() {
  return (
    <article className="py-4 md:py-12">
      <h1
        className="font-display font-medium leading-[0.98] tracking-[-0.015em] max-w-[16ch]"
        style={{ fontSize: 'var(--size-display)' }}
      >
        {about.heading}
      </h1>
      <p className="mt-4 text-ink-muted text-lg">{site.headline}</p>

      <section className="mt-16 max-w-prose">
        <h2 className="font-display text-2xl md:text-3xl font-medium mb-6">
          What I'm building now
        </h2>
        <div className="space-y-5 text-lg leading-relaxed">
          {site.pitch.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </section>

      <section className="mt-16 max-w-prose">
        <h2 className="font-display text-2xl md:text-3xl font-medium mb-6">
          About me
        </h2>
        <div className="space-y-6 text-lg leading-relaxed">
          {about.intro.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
        <TweetEmbed url={about.statueUrl} className="my-8" />
        <div className="space-y-6 text-lg leading-relaxed">
          {about.body.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
        <p className="mt-8 text-lg leading-relaxed">
          {about.cta.lead}{' '}
          <a href={`mailto:${site.email}`}>{about.cta.link}</a>
        </p>
      </section>
    </article>
  );
}
